import Widget from "components/widget/Widget";
import AnalyticsTable from "features/main-dashboard/components/AnalyticsTable";
import DailyTraffic from "features/main-dashboard/components/DailyTraffic";
import TotalSpent from "features/main-dashboard/components/TotalSpent";
import useDashboard from "hooks/useDashboard";
import {
  MdBarChart,
  MdPieChart,
  MdStorefront,
  MdPerson,
  MdList,
  MdMap,
} from "react-icons/md";
import { useState } from "react";
import useStore from "store/store";
import Loader from "components/loader/Loader";

const Dashboard = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const {
    totalProduct,
    totalSales,
    totalUsers,
    totalNewUsers,
    analyticsData,
    pagination,
    totalOrders,
  } = useDashboard(currentPage, pageSize);
  const isLoading = useStore((state) => state.isLoading);

  const transformedData = (analyticsData || []).map((item) => {
    const dimensionValues = item.dimensionValues;
    const metricValues = item.metricValues;

    return {
      date: dimensionValues[0]?.value || "N/A",
      country: dimensionValues[2]?.value || "N/A",
      city: dimensionValues[1]?.value || "N/A",
      device: dimensionValues[3]?.value || "N/A",
      activeUsers: metricValues[0]?.value || "0",
      pageViews: metricValues[2]?.value || "0",
    };
  });

  const uniqueCountries = [
    ...new Set(
      (analyticsData || []).map((item) => item.dimensionValues[2]?.value)
    ),
  ];
  const totalCountries = uniqueCountries.length;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="space-y-6 p-6">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
            <Widget
              icon={<MdList className="h-6 w-6 text-primary" />}
              title="Total Orders This Month"
              subtitle={`${totalOrders}`}
            />
            <Widget
              icon={<MdBarChart className="h-6 w-6 text-primary" />}
              title="Sales This Month"
              subtitle={`$${totalSales}`}
            />
            <Widget
              icon={<MdStorefront className="h-6 w-6 text-primary" />}
              title="Total Products"
              subtitle={totalProduct}
            />
            <Widget
              icon={<MdPerson className="h-6 w-6 text-primary" />}
              title="Total Users"
              subtitle={totalUsers}
            />
            <Widget
              icon={<MdPieChart className="h-6 w-6 text-primary" />}
              title="New Users"
              subtitle={totalNewUsers}
            />
            <Widget
              icon={<MdMap className="h-6 w-6 text-primary" />}
              title="Total Countries"
              subtitle={totalCountries}
            />
          </div>

          <div className="w-full">
            <TotalSpent />
          </div>

          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
            <div className="lg:col-span-1">
              {analyticsData && <DailyTraffic analyticsData={analyticsData} />}
            </div>
            <div className="lg:col-span-2">
              <AnalyticsTable
                tableData={transformedData}
                pagination={pagination}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
